<script setup>
import { computed } from "vue";
import Button from "@/shared/ui/button/Button.vue";
import { Badge } from "@/shared/ui/badge";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
} from "@/shared/ui/alert-dialog";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  placeholders: {
    type: Array,
    default: () => [],
  },
  participant: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(["confirm", "skip", "update:visible"]);

const placeholderCode = computed(() => props.placeholders[0] || "");

function confirm() {
  if (!placeholderCode.value || !props.participant?.participant_type_code)
    return;
  emit(
    "confirm",
    placeholderCode.value,
    props.participant.participant_type_code
  );
}

function skip() {
  emit("skip");
}
</script>

<template>
  <AlertDialog :open="visible">
    <AlertDialogContent class="sm:max-w-[480px] gap-0 p-0">
      <div class="p-6 flex flex-col gap-3">
        <AlertDialogTitle
          class="text-base font-medium leading-none text-foreground"
        >
          {{ $t("Привязка участника") }}
        </AlertDialogTitle>
        <AlertDialogDescription class="text-sm text-muted-foreground">
          {{
            $t(
              "Привязать участника к ключу-заменителю в документе? Все mention с этим ключом будут обновлены."
            )
          }}
        </AlertDialogDescription>

        <div class="flex items-center gap-2 text-sm">
          <Badge variant="outline" class="font-mono">
            {{ placeholderCode }}
          </Badge>
          <span class="text-muted-foreground">→</span>
          <Badge variant="outline" class="font-mono">
            {{ participant?.participant_type_code }}
          </Badge>
        </div>
      </div>

      <div
        class="flex justify-end gap-2 px-6 py-4 border-t border-border bg-muted/50"
      >
        <Button variant="outline" @click="skip">
          {{ $t("Пропустить") }}
        </Button>
        <Button @click="confirm">
          {{ $t("Привязать") }}
        </Button>
      </div>
    </AlertDialogContent>
  </AlertDialog>
</template>
